/**
 * Created by mac on 3/2/21
 */

const ExitControlButton = {
    name: "ExitControlButton",
    buttonType: "back_button",
    icon: bundles.controlbuttons.frames.back_icon_png,

    onClicked: function () {
        cleverapps.effects.fire("ui.exit.click");
        if (cleverapps.config.demoMode) {
            window.location.search = "";
        } else {
            cleverapps.Scenes.GetRunningScene().sceneComponent.closeAction();
        }
    },

    isAvailableOnScene: function () {
        if (cleverapps.environment.isMainScene()) {
            return false;
        }

        if (cleverapps.config.type === "battlefield" && Game.currentGame && Game.currentGame.mode === Epicart.MODE_BATTLE) {
            return false;
        }

        if (cleverapps.environment.hasScene([cleverapps.Environment.SCENE_ATLAS_ANALYZER])) {
            return true;
        }

        if (cleverapps.config.adminMode) {
            return true;
        }

        if (cleverapps.environment.hasScene([cleverapps.Environment.SCENE_CHAT])
            || (cleverapps.environment.isGameScene() && ["riddles", "heroes", "zenmatch"].indexOf(cleverapps.config.name) !== -1)) {
            return false;
        }

        return levels && levels.user && levels.user.checkAvailable(cleverapps.config.availables.EXIT_CONTROL_BUTTON);
    }
};
